// extracted by mini-css-extract-plugin
export var Base = "Breadcrumb-module--Base--b45fe";